const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Head Office Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "not_in_use_eq",
      trueLabel: "Not in Use",
      falseLabel: "In Use",
      label: "Not In Use",
    },
    defaultValue: { not_in_use_eq: false },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/admin/department-types/head-offices-filters.js